import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Theme } from '../../components';

function standardizeTagName(tagName) {
  return tagName.trim().toLowerCase();
}
function mountToNode(node, component, withTheme) {
  const props = {};
  for (let index = 0; index < node.attributes.length; index++) {
    const attribute = node.attributes[index];
    props[attribute.name] = attribute.value;
  }
  if (props.hasOwnProperty('container')) {
    throw new Error(
      `'container' cannot be use as an attribute for ${node.tagName}`,
    );
  }
  if (props.hasOwnProperty('children')) {
    throw new Error(
      `'children' cannot be use as an attribute for ${node.tagName}`,
    );
  }
  props.container = node;
  props.children = Array.prototype.slice.call(node.childNodes, 0);
  if (withTheme) {
    ReactDOM.render(<ThemeProvider theme={Theme}>{React.createElement(component, props)}</ThemeProvider>, node);
  } else {
    ReactDOM.render(React.createElement(component, props), node);
  }
}
export default (tagName = '', component = undefined, withTheme = false) => {
  tagName = standardizeTagName(tagName);
  Array.prototype.slice
    .call(document.querySelectorAll(tagName), 0)
    .forEach((node) => {
      mountToNode(node, component, withTheme);
    });
};
